import React from 'react';
import { valueForKeyPath as v } from '../../../utils.jsx';
import moment from 'moment';

class ArticleList extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.handleSelectArticle = this.handleSelectArticle.bind(this);
  }

  handleSelectAll(e) {
    if (this.props.onSelectAll) {
      this.props.onSelectAll(e.target.checked);
    }
  }

  handleSelectArticle(articleId, e) {
    if (this.props.onSelectArticle) {
      this.props.onSelectArticle(articleId, e.target.checked);
    }
  }

  render() {
    const rows = [];
    let colSpanModifier = 0;
    let i = 0;
    const showCheckboxes = this.props.showCheckboxes;
    const selectedArticles = this.props.selectedArticles || [];

    for (const article of this.props.articles) {
      const actions = [];

      if (this.props.contentspace_info.is_contentspace_admin) {
        if (this.props.actions) {
          for (const action_idx in this.props.actions) {
            const action = this.props.actions[action_idx];
            actions.push(
              <td key={action_idx} className="hide-on-mobile-600">
                <a
                  href="javascript:void(0);"
                  onClick={action.didFireAction.bind(this, article._id)}
                >
                  <i className={`fa fa-${action.icon}`} /> {action.actionName}
                </a>
              </td>,
            );
          }
        }
      }

      i++;
      const rowNr = i + this.props.offset;
      const isSelected = selectedArticles.includes(article._id);

      rows.push(
        <tr key={article._id ? article._id : 'tmp_key'}>
          {showCheckboxes && (
            <td className="text-center" style={{ width: '40px' }}>
              <input
                type="checkbox"
                checked={isSelected}
                onChange={this.handleSelectArticle.bind(this, article._id)}
              />
            </td>
          )}
          <td className="text-right">{rowNr}.</td>
          <td>
            <a
              href="javascript:void(0);"
              onClick={this.props.didSelectArticle.bind(this, article._id)}
            >
              {article.name}
            </a>
            <br />
            <em>
              {v(article, 'author.name')} ({v(article, 'author.real_name')})
            </em>{' '}
            | {moment(article.created).format('DD.MM.YYYY HH:mm')}
          </td>
          <td>
            {article.date ? (
              moment(article.date).format('DD.MM.YYYY HH:mm')
            ) : (
              <span className="text-danger">nepublikovaný</span>
            )}
          </td>
          <td className="text-center hide-on-mobile-500" style={{ verticalAlign: 'middle' }}>
            {v(article, 'pin2top') ? parseInt(v(article, 'pin2top')) : ''}
          </td>
          <td className="text-center hide-on-mobile-600" style={{ verticalAlign: 'middle' }}>
            <span style={{ display: 'block' }}>
              {v(v(article, 'location', [])[0], 'title')}
            </span>
            {v(article, 'pin2locality')}
          </td>
          <td className="text-center hide-on-mobile-600" style={{ verticalAlign: 'middle' }}>
            <span style={{ display: 'block' }}>
              {v(v(article, 'section', {}), 'name', '')}
            </span>
            {v(article, 'pin2category')}
          </td>
          <td className="text-center hide-on-mobile-600" style={{ verticalAlign: 'middle' }}>
            {article.views_total || 0}
          </td>
          {actions}
        </tr>,
      );
    }

    const allSelected = this.props.articles.length > 0 &&
                        this.props.articles.every(article => selectedArticles.includes(article._id));

    return (
      <div>
        <table className="table" style={{ fontSize: '89%' }}>
          <thead>
            <tr>
              {showCheckboxes && (
                <th className="text-center" style={{ width: '40px' }}>
                  <input
                    type="checkbox"
                    checked={allSelected}
                    onChange={this.handleSelectAll}
                  />
                </th>
              )}
              <th className="text-right">#&nbsp;</th>
              <th>Názov / Autor / Dátum</th>
              <th>Platnosť od</th>
              <th className="text-center hide-on-mobile-500">Titulka</th>
              <th className="text-center hide-on-mobile-600">Lokalita</th>
              <th className="text-center hide-on-mobile-600">Kategória</th>
              <th className="text-center hide-on-mobile-600">Prečítania</th>
              {this.props.actions ? (
                <th colSpan={this.props.actions.length + colSpanModifier}>
                  &nbsp;
                </th>
              ) : null}
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </div>
    );
  }
}

export default ArticleList;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ArticleList.jsx